/**
 * IMPORTS
 */

import { IAtualizarClientePayload } from "@/hooks/usuários/atualizar-cliente/index.d";
import { IAtualizarUsuarioClientePayload } from "@/hooks/usuários/atualizar-usuario-do-cliente/index.d";
import { ICreateClientPayload } from "@/hooks/usuários/criar-cliente";
import { ICreateUsuarioClientePayload } from "@/hooks/usuários/criar-usuarios-clientes/interface";

import { customersRepository } from "@/repositories/custumers";

/**
 * Função que busca dados dos pedidos finalizados 🛠️.
 */
const handleGetCustomers = async (
  accessToken: string,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await customersRepository.getAllCustomers(
      accessToken,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR AO BUSCAR CLIENTES: ", error);

    return error;
  }
};

/**
 * Função que busca dado de um usuário 🛠️.
 */
const handleBuscarPorUsuario = async (accessToken: string, user_id: number) => {
  try {
    const data = await customersRepository.buscarPorUsuario(accessToken, user_id);

    return data;
  } catch (error: any) {
    console.log("ERROR AO BUSCAR POR UM USUÁRIO: ", error);

    return error;
  }
};

/**
 * Função que busca todos o usuario de um cliente 🛠️.
 */
const handleGetUsuariosCliente = async (
  accessToken: string,
  user_cliente_id: number,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await customersRepository.buscarUsuariosPorCliente(
      accessToken,
      user_cliente_id,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR AO BUSCAR USUARIOS DO CLIENTE: ", error);

    return error;
  }
};

/**
 * Função que criar dados do usuário 🛠️.
 */
const handleCreateUsuario = async (accessToken: string, payload: ICreateClientPayload) => {
  try {
    const data = await customersRepository.criarNovoUsuario(accessToken, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR AO BUSCAR CLIENTES: ", error);

    return error;
  }
};

/**
 * Função que faz a criação de usarios para cliente 🛠️.
 */
const handleCreateUsuariosClientes = async (
  accessToken: string,
  payload: ICreateUsuarioClientePayload
) => {
  try {
    const data = await customersRepository.criarUsuariosCliente(accessToken, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR AO BUSCAR CLIENTES: ", error);

    return error;
  }
};

/**
 * Função que atualizar dados do usuário🛠️.
 */
const handleAtualizarUsuario = async (
  accessToken: string,
  user_id: number,
  payload: IAtualizarClientePayload
) => {
  try {
    const data = await customersRepository.atualizarUsuario(accessToken, user_id, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR AO ATUALIZAR USUARIO: ", error);

    return error;
  }
};

/**
 * Função que atualizar dados do usuário de um cliente 🛠️.
 */
const handleAtualizarUsuarioCliente = async (
  accessToken: string,
  user_id: number,
  payload: IAtualizarUsuarioClientePayload
) => {
  try {
    const data = await customersRepository.atualizarUsuarioCliente(accessToken, user_id, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR AO ATUALIZAR USUARIO DO CLIENTE:", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export {
  handleAtualizarUsuario,
  handleAtualizarUsuarioCliente,
  handleBuscarPorUsuario,
  handleCreateUsuario,
  handleCreateUsuariosClientes,
  handleGetCustomers,
  handleGetUsuariosCliente,
};
